import styled from 'styled-components';

import { Container as SemanticContainer } from 'semantic-ui-react';

import {
  Header as TextHeader, Loader as LoaderLayout, Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled(SemanticContainer)`
  &&& {
    @media only screen and (min-width: 1200px) {
      width: 2080px;
    }

    display: flex;
    flex-direction: column;
    ${({ center }) => (center ? 'align-items: center;' : '')}
  }

  padding: 78px 20px 20px 20px;
`;

export const ZeroState = styled.div`
  display: flex;
  margin: 80px;
  height: 600px;
  align-items: center;
  flex-direction: column;
`;

export const VideoContainer = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const Header = styled.div`
  display: flex;
  padding: 10px;
  justify-content: space-between;
  flex-direction: column;
`;

export const Link = styled.a`
  align-self: flex-end;
`;

export const Content = styled.div`
  display: flex;
`;

export const ContentLeftSide = styled.div`
  padding: 10px;
  width: 335px;
  min-width: 335px;
`;

export const ContentRightSide = styled.div`
  padding: 10px;
  flex-shrink: 1;
  min-width: 0;
  width: 100%;
`;

export const Card = styled(SegmentLayoutComponent)`
  &&& {
    padding: 20px;
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const CardHeader = styled(Header)`
  flex-direction: row;
  padding: 0;
  margin: 0;
`;

export const Text = styled(TextHeader)`
  margin: 0;
`;

export const Message = styled(TextLayoutComponent)``;

export const FiltersContainer = styled.div`
  display: flex;
`;

export const FilterItem = styled.div`
  margin-left: 15px;
`;

export const CardsContainer = styled.div``;

export const Loader = styled(LoaderLayout)``;

export const TitleContainer = styled.div``;

export const FrameVideo = styled.iframe`
  width: 100%;
`;

export const ProjectDropdownContainer = styled.div`
  width: 350px;
`;
